import Worker from 'worker-loader!./worker.js'

new Worker()
